<script>
import Edit from './Edit.vue'
export default {
  extends: Edit,
  created() {
    this.showModal = true
  },
  computed: {
    title() {
      return 'Create Category'
    },
    action() {
      return 'create'
    },
    getUri() {
      return ''
    },
    submitUri() {
      return 'term/create'
    }
  }
}
</script>
